import { render } from "./VersionLog.vue?vue&type=template&id=1a4579f2"
import script from "./VersionLog.vue?vue&type=script&lang=js"
export * from "./VersionLog.vue?vue&type=script&lang=js"

import "./VersionLog.vue?vue&type=style&index=0&id=1a4579f2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__